/**
 * 계정정보찾기 Use Cases
 * FSD: features/account-recovery/use-cases
 */

import { findId, requestPasswordReset } from "../api/account-recovery.api";
import {
  FindIdRequest,
  FindIdResponse,
  ResetPasswordRequest,
  ResetPasswordResponse,
} from "../model/account-recovery.types";

/**
 * 아이디 찾기 Use Case
 */
export const findIdUseCase = {
  async execute(req: FindIdRequest): Promise<FindIdResponse> {
    const result = await findId(req);
    return result;
  },
};

/**
 * 비밀번호 초기화 Use Case
 */
export const resetPasswordUseCase = {
  async execute(req: ResetPasswordRequest): Promise<ResetPasswordResponse> {
    const result = await requestPasswordReset(req);
    return result;
  },
};
